import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { TrackRecordOverview } from "@/types/track-record.types";

// Spec 079 (US1) — a RÉGUA DO GÊMEO no cliente.
//
// Só leitura: a régua é derivada, e nada nesta tela escreve. Quem a INVALIDA são as mutações do
// ciclo fechado, em `../hooks.ts`: `useConfirmClassification` e `useResolvePendency` (as duas que
// existem hoje). Falta ainda a edição da política em `/organizacao`, que só chega com a US4 —
// mudar os limiares reclassifica toda régua exibida.
//
// ⚠️ `useResolvePendency` é a menos óbvia e a mais importante: ela não escreve NENHUMA linha da
// régua, mas move o marco zero — redefine quais compromissos contam e muda todos os números de uma
// linha de uma vez.
//
// ⚠️ A régua NÃO entra em `useRealtimeInvalidate`, e é decisão declarada: uma estatística que se
// move devagar não deve competir com evento de chão de fábrica pela mesma faixa de atualização.

/** Chave exclusiva. Sem parâmetros: o período não é filtrável nesta versão (R4). */
export const trackRecordKey = ["closed-loop", "track-record"] as const;

export function useTrackRecord() {
  return useQuery<TrackRecordOverview>({
    queryKey: trackRecordKey,
    queryFn: () => api.get<TrackRecordOverview>("/api/v1/track-record"),
  });
}
